import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_and_wrkrs_representatives_free_to_meet_wout_the_prese'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_and_wrkrs_representatives_free_to_meet_wout_the_prese',
  name: "Are workers and workers' representatives free to meet without the presence of management?",
  description:
    "This question also covers the example of workers meeting to discuss the possibility of forming a union.\r\r\n\r\r\nWorkers' Representatives Recommendation, 1971 (No. 143): 2. For the purpose of this Recommendation the term workers' representatives means persons who are recognized as such under national law or practice, whether they are--\r\r\n(a) trade union representatives, namely representatives designated or elected by trade unions or by the members of such unions; or\r\r\n(b) elected representatives, namely representatives who are freely elected by the workers of the undertaking in accordance with provisions of national laws or regulations or of collective agreements and whose functions do not include activities which are recognized as the exclusive prerogative of trade unions in the country concerned.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12190,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
